<div class="flex__child--auto flex--column">
  <router-outlet></router-outlet>
</div>
